import * as React from 'react';
import { Icon } from 'semantic-ui-react';

interface IStartViewTileProps {
    label?: string;
    labelColor?: 'white' | 'black';
    imageSource?: string;
    onClick?: () => void;
    contextMenuUrl?: string; // URL to open in a new tab on right-click
    isFromTop: boolean; // Optional prop to indicate if the tile is from the top menu
}

export default class StartViewTile extends React.Component<IStartViewTileProps> {
    handleContextMenu = (event: React.MouseEvent) => {
        event.preventDefault(); // Prevent the default browser context menu
        if(this.props.isFromTop) {
             window.open(this.props.contextMenuUrl, '_blank'); // Open the URL in a new tab
             return;
        }
        const x = event.clientX; // Use viewport-relative X position
        const y = event.clientY; // Use viewport-relative Y position

        // Trigger the global context menu
        window.dispatchEvent(
            new CustomEvent('showGlobalContextMenu', {
                detail: { x, y, url: this.props.contextMenuUrl },
            })
        );
    }

    render() {
        const { imageSource, label, onClick, labelColor = 'black' } = this.props;

        let graphicComponent: JSX.Element = imageSource ? (
            <img src={imageSource} alt="Tile Graphic" />
        ) : (
            <></>
        );

        let labelComponent: JSX.Element = label ? (
            <div className={`start-view-tile-label ${labelColor}`}>
                <Icon className="custom-chevron" name="chevron right" />
                <span>{label}</span>
            </div>
        ) : (
            <></>
        );

        return (
            <div
                className="start-view-tile"
                onClick={onClick}
                onContextMenu={this.handleContextMenu} // Add context menu handler
            >
                {graphicComponent}
                {labelComponent}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/MainView/StartViewTile.tsx